<script setup lang="ts">
import type { FileField, LocationRecord } from '~/types/datocms'

interface LocationListItemProps {
  data: LocationRecord
  image: FileField
}

defineProps<LocationListItemProps>()

const { emitterEmit } = useEmitter()

onBeforeUnmount(() => {
  emitterEmit('hotspotLeave')
})
</script>

<template>
  <div
    ref="itemRef"
    class="overflow-hidden"
    @mouseover="
      emitterEmit('hotspotEnter', {
        universal: true,
        label: 'Show more',
        iconRight: 'custom:arrow-right'
      })
    "
    @mouseleave="emitterEmit('hotspotLeave')"
  >
    <NuxtLink
      v-if="image"
      :to="useLocalePathByType(data._modelApiKey, (data.slug as string) ?? undefined)"
      class="relative block cursor-none text-2xl uppercase transition-colors duration-300 lg:text-4xl"
    >
      <Image
        class="aspect-[16/10] w-full object-cover"
        loading="lazy"
        :src="image?.responsiveImage ? image?.responsiveImage?.src : image?.url"
        :srcset="image?.responsiveImage ? image?.responsiveImage?.webpSrcSet : undefined"
        :width="image?.responsiveImage ? image?.responsiveImage?.width : (image?.width ?? 1920)"
        :height="image?.responsiveImage ? image?.responsiveImage?.height : (image?.height ?? 1080)"
        :alt="image?.alt ?? ''"
      />
      <div
        class="absolute left-0 top-0 z-2 flex h-full w-fit rotate-180 items-center justify-between gap-2 whitespace-nowrap py-2 text-sm mix-blend-difference [text-orientation:mixed] [writing-mode:vertical-lr]"
      >
        <span>
          {{ image?.title }}
        </span>
        <span class="inline-flex gap-4">
          {{ data.country?.locale }}
          <span>{{ data.category?.name }}</span>
        </span>
      </div>
    </NuxtLink>
  </div>
</template>
